import { gql } from "@apollo/client";

export const ALL_MODULES = gql`
  query AllModules {
    allModules {
      results
      error
    }
  }
`;
export const ALL_RIGHTS = gql`
  query AllRights {
    allRights {
      results
      error
    }
  }
`;

export const BULK_ACTIVATE_DEACTIVATE_RIGHTS = gql`
  mutation BulkActivateDeactivateRights(
    $rightIds: [Int!]!
    $isActive: Boolean!
  ) {
    bulkActivateDeactivateRights(rightIds: $rightIds, isActive: $isActive)
  }
`;

export const ACTIVATE_RIGHTS = gql`
  mutation ActivateRights(
    $rightIds: [Int!]!
    $isActive: Boolean!
    $userId: Int!
  ) {
    activateRights(rightIds: $rightIds, isActive: $isActive, userId: $userId) {
      id
      isActive
    }
  }
`;

export const DEACTIVATE_RIGHTS = gql`
  mutation DeactivateRights(
    $rightIds: [Int!]!
    $isActive: Boolean!
    $userId: Int!
  ) {
    deactivateRights(
      rightIds: $rightIds
      isActive: $isActive
      userId: $userId
    ) {
      id
      isActive
    }
  }
`;

export const ALL_ROLEGROUPS = gql`
  query AllRoleGroups {
    allRoleGroups {
      results
      error
    }
  }
`;
export const BULK_ACTIVATE_DEACTIVATE_ROLE_GROUPS = gql`
  mutation BulkActivateDeactivateRoleGroups(
    $roleGroupIds: [Int!]!
    $isActive: Boolean!
    $userId: Int!
  ) {
    bulkActivateDeactivateRoleGroups(
      roleGroupIds: $roleGroupIds
      isActive: $isActive
      userId: $userId
    )
  }
`;

export const ALL_ROLE = gql`
  query Role {
    allRoles {
      id
      role
      roleDescription
      roleGroupId
      roleGroup
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }
`;
export const BULK_ACTIVATE_DEACTIVATE_ROLES = gql`
  mutation BulkActivateDeactivateRoles($roleIds: [Int!]!, $isActive: Boolean!) {
    bulkActivateDeactivateRoles(roleIds: $roleIds, isActive: $isActive)
  }
`;

export const CREATE_RIGHT = gql`
  mutation CreateRight(
    $title: String
    $icon: String
    $action: String
    $moduleId: Int
    $module: String
    $createdBy: Int!
  ) {
    createRight(
      newRight: {
        title: $title
        icon: $icon
        action: $action
        moduleId: $moduleId
        module: $module
        createdBy: $createdBy
        adminOnly: false
      }
    ) {
      results
      error
    }
  }
`;

export const UPDATE_RIGHT = gql`
  mutation UpdateRight(
    $id: Int
    $title: String
    $icon: String
    $action: String
    $moduleId: Int
    $module: String
    $createdBy: Int!
  ) {
    updateRight(
      updatedRight: {
        id: $id
        title: $title
        icon: $icon
        action: $action
        moduleId: $moduleId
        module: $module
        createdBy: $createdBy
        isActive: 1
        adminOnly: false
      }
    ) {
      results
      error
    }
  }
`;

export const CREATE_MODULE = gql`
  mutation CreateModule(
    $id: Int
    $module: String!
    $icon: String
    $createdBy: Int
    $isActive: Byte
  ) {
    createModule(
      newModule: {
        id: $id
        module: $module
        icon: $icon
        createdBy: $createdBy
        isActive: $isActive
      }
    ) {
      results
      error
    }
  }
`;
export const UPDATE_MODULE = gql`
  mutation UpdateModule(
    $id: Int
    $module: String!
    $icon: String
    $createdBy: Int
    $isActive: Byte
  ) {
    updateModule(
      updatedModule: {
        id: $id
        module: $module
        icon: $icon
        createdBy: $createdBy
        isActive: $isActive
      }
    ) {
      results
      error
    }
  }
`;
export const CREATE_ROLE_GROUP = gql`
  mutation CreateRoleGroup($id: Int, $roleGroup: String, $createdBy: Int) {
    createRoleGroup(
      newRoleGroup: {
        id: $id
        roleGroup: $roleGroup
        createdBy: $createdBy
        isActive: 1
      }
    ) {
      results
      error
    }
  }
`;
export const UPDATE_ROLE_GROUP = gql`
  mutation UpdateRoleGroup($id: Int, $roleGroup: String, $createdBy: Int) {
    updateRoleGroup(
      updatedRoleGroup: {
        id: $id
        roleGroup: $roleGroup
        createdBy: $createdBy
        isActive: 1
      }
    ) {
      results
      error
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation CreateRole(
    $id: Int
    $role: String
    $roleDescription: String
    $roleGroupId: Int
    $roleGroup: String
    $createdBy: Int
    $companyId: Int
    $isActive: Byte
  ) {
    createRole(
      newRole: {
        id: $id
        role: $role
        roleDescription: $roleDescription
        roleGroupId: $roleGroupId
        roleGroup: $roleGroup
        createdBy: $createdBy
        companyId: $companyId
        isActive: $isActive
      }
    ) {
      id
      role
      roleDescription
      roleGroupId
      roleGroup
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
    }
  }
`;

export const UPDATE_ROLE = gql`
  mutation UpdateRole(
    $id: Int
    $role: String
    $roleDescription: String
    $roleGroupId: Int
    $roleGroup: String
    $createdBy: Int
    $companyId: Int
    $isActive: Byte
  ) {
    updateRole(
      updatedRole: {
        id: $id
        role: $role
        roleDescription: $roleDescription
        roleGroupId: $roleGroupId
        roleGroup: $roleGroup
        createdBy: $createdBy
        companyId: $companyId
        isActive: $isActive
      }
    ) {
      id
      role
      roleDescription
      roleGroupId
      roleGroup
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
    }
  }
`;

export const ALL_ROLE_RIGHTS = gql`
  query AllModuleRights {
    allModuleRights
  }
`;
export const ALL_ROLE_RIGHTS_BY_ROLE = gql`
  query ModuleRightsByRoleId($roleId: Int!) {
    moduleRightsByRoleId(roleId: $roleId)
  }
`;
export const CREATE_ROLE_RIGHTS = gql`
  mutation CreateRoleRight(
    $roleId: Int!
    $role: String
    $rightId: Int!
    $moduleId: Int!
    $right: String
    $createPermission: Byte
    $editPermission: Byte
    $activatePermission: Byte
    $exportPermission: Byte
    $createdBy: Int!
    $companyId: Int
    $company: String
  ) {
    createRoleRight(
      newRoleRight: {
        roleId: $roleId
        role: $role
        rightId: $rightId
        right: $right
        moduleId: $moduleId
        createPermission: $createPermission
        editPermission: $editPermission
        activatePermission: $activatePermission
        exportPermission: $exportPermission
        isActive: true
        createdBy: $createdBy
        companyId: $companyId
        company: $company
      }
    ) {
      id
      roleId
      role
      rightId
      right
      createPermission
      editPermission
      activatePermission
      exportPermission
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }
`;
export const CREATE_ROLE_RIGHTS_BULK = gql`
  mutation CreateRoleRightsBulk($newRoleRights: [RoleRightsInput]!) {
    createRoleRightsBulk(newRoleRights: $newRoleRights) {
      id
      roleId
      role
      moduleId
      module
      rightId
      right
      createPermission
      editPermission
      activatePermission
      exportPermission
      isActive
      statusFlag
      createdBy
      createdDate
      updatedBy
      updatedDate
      companyId
      company
    }
  }
`;
export const ACTIVATE_RIGHT = gql`
  mutation ActivateRight($id: ID!) {
    activateRight(id: $id) {
      id
      isActive
    }
  }
`;

export const DEACTIVATE_RIGHT = gql`
  mutation DeactivateRight($id: ID!) {
    deactivateRight(id: $id) {
      id
      isActive
    }
  }
`;
